import { cn } from '@coas/ui/lib';
import { productFilterSchema } from '@coas/validators/payload';
import IconChevronRight from '~/shared/assets/icons/chevron-right.svg';
import type { PropsOf } from '~/shared/lib';
import { Price } from '~/shared/ui/price';
import { filterItems } from '../config/filterItems';

type ProductFilterTriggerFallbackProps = Omit<PropsOf<'button'>, 'onClick'>;

export default ({ className, ...props }: ProductFilterTriggerFallbackProps) => {
    const filter = productFilterSchema.parse({});

    return (
        <>
            <button {...props} className={cn('md:hidden', className)} />
            <div className={'hidden md:contents'}>
                {filterItems.map(item => {
                    return (
                        <button
                            key={item.key}
                            type={'button'}
                            className={'flex items-center justify-center gap-x-1 px-6 py-2.5 text-14'}
                        >
                            <div className={cn('mb-0.5 size-3.5')} />
                            <span className={'space-x-3'}>
                                <span className={'text-neutral-950'}>{item.title}</span>
                                {item.key === 'price' && (
                                    <span className={'font-300 text-neutral-500'}>
                                        <Price withoutCurrency>{filter[item.key][0]}</Price>
                                        {' — '}
                                        <Price withoutCurrency>{filter[item.key][1]}</Price>
                                    </span>
                                )}
                            </span>
                            <IconChevronRight className={'mb-0.5 size-3.5 stroke-neutral-400'} />
                        </button>
                    );
                })}
            </div>
        </>
    );
};
